import React, { Component } from "react";
import PropTypes from "prop-types";
import { MicrosoftAuthenticationService } from "@services";
import utils from "@utils";
import ProgressButton from "react-progress-button";
import { withMsal } from "@azure/msal-react";
import { ENV_OPTIONS, ROUTES } from "@constants";
import { ADOPERATIONS } from "@constants/index";

class ChangePassword extends Component {
	constructor(props) {
		super(props);

		this.state = {
			resetPasswordButtonState: "",
		};
	}

	componentDidMount() {
		const { isImpersonating } = MicrosoftAuthenticationService;

		if (isImpersonating()) {
			this.updateProgressButton("disabled");
		}
	}

	updateProgressButton = (value, callback) => {
		this.setState({ resetPasswordButtonState: value }, callback);
	};

	handleADResetPassword = () => {
		const {
			user,
			msalContext: { instance: msalInstance },
		} = this.props;

		this.updateProgressButton("loading");

		msalInstance
			.loginRedirect({
				loginHint: user.Email,
				authority: ENV_OPTIONS.adb2c.policies.resetPassword,
				scopes: ENV_OPTIONS.adb2c.scopes,
				redirectUri: ROUTES.ADCallback,
				state: utils.encodeADState({ operation: ADOPERATIONS.changePassword }),
				extraQueryParameters: {
					uxConfig: utils.encodeADState({ disabledInputs: ["email"] }),
				},
			})
			.finally(() => this.updateProgressButton(""));
	};

	render() {
		const { lang } = global;
		const { resetPasswordButtonState } = this.state;

		return (
			<div className="my-account-panel">
				<div className="my-account-panel-header">
					<h4 className="title">{lang.t("Change Password")}</h4>
				</div>
				<div className="my-account-panel-body">
					<div className="flex-center flex-direction-column">
						<ProgressButton
							id="reset-password-ad"
							className="btn btn-primary btn-medium"
							state={resetPasswordButtonState}
							onClick={this.handleADResetPassword}
						>
							{lang.t("Change")}
						</ProgressButton>
					</div>
				</div>
			</div>
		);
	}
}

ChangePassword.propTypes = {
	user: PropTypes.object,
	msalContext: PropTypes.object.isRequired,
};

ChangePassword.defaultProps = {
	user: {},
};

export default withMsal(ChangePassword);
